import { useState, useEffect } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';

const PROG = 'ChartRepeatPurchaseRate.js';
const COLORS = ['#20c997', '#adb5bd'];

const ChartRepeatPurchaseRate = (props) => {

  const [chartData, setChartData] = useState(null);
  const [repeatPurchaseRate, setRepeatPurchaseRate] = useState(0);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const loadChartData = async () => {
      const FUNCTION = 'loadChartData';
      try {
        setIsLoadingData(true);
        const _chartDataResponse = await apiComms.getChartDataRepeatPurchaseRate(props.timeRange);
        if (_chartDataResponse && !_chartDataResponse.isErr) {
          const _response = _chartDataResponse.response;
          setChartData([
            {
              name : 'Repeat Customers',
              value : Number(_response.repeatCustomers ?? 0)
            },
            {
              name : 'One-Time Customers',
              value : Number(_response.oneTimeCustomers ?? 0)
            }
          ]);
          setRepeatPurchaseRate(Number(_response.repeatPurchaseRate ?? 0));
        }
        setIsLoadingData(false);
      }
      catch (e) {
        logger.error('Exception Occured', { PROG, FUNCTION });
        console.log('Exception: '+e+', '+e.stack);
      }
    };

    loadChartData();
  }, [props.timeRange]);

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 280, position : 'relative' }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.some((item) => item.value > 0) ? (
            <>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    data={chartData}
                    dataKey='value'
                    nameKey='name'
                    innerRadius={70}
                    outerRadius={105}
                    paddingAngle={2}
                  >
                    { chartData.map((entry, index) => (
                      <Cell key={ entry.name } fill={ COLORS[index % COLORS.length] } />
                    )) }
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
              <div style={ styles.centerLabel }>
                <div style={ styles.centerValue }>{ repeatPurchaseRate.toFixed(1) }%</div>
                <div style={ styles.centerText }>Repeat Rate</div>
              </div>
            </>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Repeat Purchase Rate
        </div>
      </div>
    </div>
  );
};

const styles = {
  centerLabel : {
    position : 'absolute',
    top : '50%',
    left : '50%',
    transform : 'translate(-50%, -58%)',
    textAlign : 'center',
    pointerEvents : 'none'
  },
  centerValue : {
    fontSize : 24,
    fontWeight : 800,
    color : '#1f2933'
  },
  centerText : {
    fontSize : 12,
    color : '#6c757d'
  }
};

export default ChartRepeatPurchaseRate;
